var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3364 11.1259C26.3546 11.1259 18.1787 -3.03509 11.1668 9.10528C18.1732 -3.03509 1.82131 -3.03509 8.83318 9.10528C1.8268 -3.03509 -6.34915 11.1259 7.66362 11.1259C-6.35464 11.1259 1.82131 25.287 8.83318 13.1466C1.8268 25.287 18.1787 25.287 11.1668 13.1466C18.1732 25.2924 26.3491 11.1259 12.3364 11.1259Z",
    fill: "#1DDFEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower);
export default __webpack_public_path__ + "static/media/flower.c59241abdc7c21ca1a73baefb7b9d738.svg";
export { ForwardRef as ReactComponent };